export default new class {
    incrementActiveSaves() {
        return {
            type: 'INCREMENT_ACTIVE_SAVES',
            payload: {},
        };
    }

    decrementActiveSaves() {
        return {
            type: 'DECREMENT_ACTIVE_SAVES',
            payload: {},
        };
    }

    incrementFailedSaves() {
        return {
            type: 'INCREMENT_FAILED_SAVES',
            payload: {},
        };
    }
}